<template>
  
    
    <div class="home" style="background-color:#ffffff; border-radius: 20px;  ">
    <div class="form-row">
      <h1 class="col-8" style="text-align: right;">Dispositivos Activos</h1><br>
      <div class="col-3"></div>
      <router-link to="/home">
        <b-button variant="outline-success" style="margin: 10px">
          <div class="h6 mb-1">
            <b-icon-arrow-left-square></b-icon-arrow-left-square>
          </div>
          <div style="font-size: 12px;">
            Inicio
          </div>
        </b-button>
      </router-link>
      </div>
      <div class="row justify-content-center " >
        <label class="counter" >{{ catTotal }}</label> 
      </div>
      <br><br>
    </div>
    
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
//import {mostrarMensajeErrorCatch, mostrarMensajeInformativo, mostrarMensajeExitoso, mostrarMensajeError} from '../../mixins/mensajes';

export default {
   // props: {
   // email: {
   //   type: String
   // }
  //},
  data() {
       
    return {
    }
  },

  computed: {
    ...mapState({
        catTotal: state => state.catalogos.catTotal
    }),

    ...mapState(["cargando"]),

  },

  methods: {
    ...mapActions("catalogos", ["obtenerTotal"]),
    ...mapMutations(["setearCargando"]),
  },
  //mounted() {
  //  if (localStorage.aleatorio) {
  //    this.aleatorio = localStorage.aleatorio;
  //  }
  //},
  //watch: {
  //  aleatorio(newEmail) {
  //    localStorage.aleatorio = newEmail;
  //  }
  //}
  mounted(){
    
    this.obtenerTotal();
  if (sessionStorage.aleatorio != 1379248){
    this.$router.push({name: "/" });
  }
  
   // this.$router.push({name: "sitios" });
  
},
}
</script>
<style>
  .home{
    margin: 13%;
    margin-bottom:1%;
  }
  .counter{
font-size:70px;
font-family: Ds-Digital;
text-align:center;

} 
</style>